import { render, staticRenderFns } from "./ErkezesTavozasSzallas.vue?vue&type=template&id=0b488de2&"
import script from "./ErkezesTavozasSzallas.vue?vue&type=script&lang=ts&"
export * from "./ErkezesTavozasSzallas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports